export const fleetUrls = {
  assets: {
    list: 'my-fleet/assets/',
    update: (assetId: string) => `my-fleet/assets/${assetId}/`,
    updateDocuments: (assetId: string) => `my-fleet/assets/${assetId}/documents/`,
    refuel: {
      create: (assetId: string) => `my-fleet/refuel/${assetId}/`,
    },
  },
  drivers: {
    list: 'my-fleet/drivers/',
    create: 'my-fleet/drivers/',
    detail: (driverId: string) => `my-fleet/drivers/${driverId}/`,
    update: (driverId: string) => `my-fleet/drivers/${driverId}/`,
    photos: {
      list: (driverId: string) => `my-fleet/drivers/${driverId}/photos/`,
      verify: 'my-fleet/drivers/verify-photo/',
    },
    subClients: {
      update: (driverId: string) => `my-fleet/drivers/${driverId}/sub-clients/`,
    },
  },
  maintenance: {
    types: {
      list: 'my-fleet/maintenance-types/',
      create: 'my-fleet/maintenance-types/',
      update: (maintenanceTypeId: string) => `my-fleet/maintenance-types/${maintenanceTypeId}/`,
    },
    rules: {
      list: 'my-fleet/maintenance-configurations/',
      create: 'my-fleet/maintenance-configurations/',
      update: (configurationId: string) => `my-fleet/maintenance-configurations/${configurationId}/`,
    },
  },
  services: {
    list: 'my-fleet/assets/services/',
    create: 'my-fleet/assets/services/',
    cancel: (serviceId: string) => `my-fleet/assets/services/${serviceId}/cancel/`,
    asset: {
      list: (assetId: string) => `my-fleet/assets/${assetId}/services/`,
      create: (assetId: string) => `my-fleet/assets/${assetId}/service-job/`,
    },
  },
  operational: {
    listByAsset: (assetId: string) => `report/operational/asset/${assetId}/`,
    listByGroup: (groupId: string) => `report/operational/group/${groupId}/`,
    reports: {
      list: 'report/operational/file/',
      create: 'report/operational/file/',
      download: (reportId: string) => `report/operational/file/${reportId}/`,
      delete: (reportId: string) => `report/operational/file/${reportId}/`,
    },
  },
};
